export default {
  CreditsCardMenu: () => import("@/components/credits/CreditsCardMenu.vue"),
  CreditsCard: () => import("@/components/credits/CreditsCard.vue"),
};
